import WalletStatement from './WalletStatementContainer';
export default WalletStatement;